<template>
    <modal
            name="comm-modal"
            :pivotY="0.2"
            height="auto"
            :width="'50%'"
            @before-open="beforeOpen"
            @before-close="beforeClose"
            :height="'auto'"
            :scrollable="true">

        <div class="border-b p-4 flex justify-between items-center">
            <div class="text-base text-gray-800">
                {{ modalTitle }}
            </div>

            <a href="#"
               v-on:click.prevent="$modal.hide('comm-modal')"
               class="text-gray-500 hover:text-gray-700">
                <svg width="20" height="20" stroke-width="2" class="align-middle" stroke="currentColor" fill="none">
                    <use xlink:href="/static/img/feather-sprite.svg#x-circle"/>
                </svg>
            </a>
        </div>

        <div class="p-4">
            <div class="form-line">
                <input type="text" class="input-standard" v-model="subject" placeholder="Subject.."/>
            </div>
<!--            <textarea-field v-model="message"></textarea-field>-->
            <div class="form-line">
              <textarea
                      class="input-standard"
                      style="height:300px;"
                      v-model="message"
              >
              </textarea>
            </div>
            <div class="mt-6 flex items-center">
                <SubmitButton2 label="Send" :onClick="send" :loading="loading"/>
            </div>
        </div>
    </modal>
</template>

<script>
  import { EventBus }   from '@/shared/event-bus'
  import SubmitButton2  from '@/shared/components/form/SubmitButton2'
  import axios          from "axios";

  export default {

    components : {
      SubmitButton2
    },

    data() {
      return {
        clientId: null,
        modalTitle: 'Send message to Broker',
        loading : false,
        message: '',
        subject: ''
      }
    },

    methods : {

      beforeOpen(event) {
        this.clientId = event.params != null && event.params.clientId != null ? event.params.clientId : null;
        // if client ID is not null then broker is sending message to client.
        if (this.clientId !== null) {
          this.modalTitle = 'Send message to Client';
        }
      },

      beforeClose(event) {
        this.clientId = null;
        this.message = '';
        this.subject = '';
      },

      send() {
        if (this.message === "" || this.subject === "") {
          EventBus.$emit('notification-event', {
            'type'   : 'error',
            'message': 'Please make sure you have entered the subject and message body.'
          });
          return;
        }
        this.loading = true;

        axios.post(process.env.VUE_APP_API_URL + '/api/submit/send-message', {
          clientId : this.clientId,
          message: this.message,
          subject: this.subject
        },{
          headers : {
            'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
          }
        }).then(response => {
          this.loading = false;
          EventBus.$emit('notification-event', {
            'type'   : 'success',
            'message': 'Message successfully sent.'
          })
          this.$modal.hide('comm-modal');

        }).catch(e => {
          this.loading = false;
          EventBus.$emit('notification-event', {
            'type'   : 'error',
            'message': 'There is an error sending message.'
          })
        });
      }

    }
  }
</script>